import React from 'react';
import Header from "../layouts/home/Header";
import Footer from "../layouts/home/Footer";
import {Outlet} from "react-router-dom";
import './home.css'

function HomeScaffold(props) {
    return (
        <div className={'body'}>
            <Header/>
            <div className="content">
                <Outlet/>

            </div>
            <Footer/>
        </div>
    );
}

export default HomeScaffold;